import { useTranslation } from 'libs/i18n'
import type { Option } from 'shared/components/ContextMenu/types'
import type { ConditionItem } from 'features/conditions/types/conditions.types'

type UseContextMenuOptionsProps = {
	onEdit: (condition: ConditionItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Edit'),
			action: (_id: number, condition: ConditionItem) => onEdit(condition)
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
